import { useTranslation } from 'react-i18next'

type infoSection = {
  heading: string
  description: string
}
export const MspAdditionalInfo = () => {
  const { t } = useTranslation('msp')

  const items = t('additionalInfo.sections', {
    returnObjects: true
  }) as infoSection[]

  return (
    <>
      <h2 className="ds-text-heading--2xl ds-u-margin-bottom--3">
        {t('additionalInfo.heading')}
      </h2>
      <div className="ds-u-lg-display--flex my-u-lg-gap-x--12">
        {items.map((item) => (
          <div key={item.heading} className="ds-u-display--inline-block ds-u-border-top--1 ds-u-padding-top--3">
            <h3 className="ds-text-heading--xl ds-u-margin-bottom--1">{item.heading}</h3>
            <div>{item.description}</div>
          </div>
        ))}
      </div>
    </>
  )
}
